export const sortScoreboardPlayers = (players, scoreHistory, currentPlayerId) => {
  const roundCount = players.reduce((count, player) =>
    Math.max(count, (scoreHistory[player.id] || []).length), 0);
  const entries = players.map((player, index) => {
    let total = 0;
    const scores = scoreHistory[player.id] || [];
    const totals = Array.from({ length: roundCount }, (_, round) => {
      total += scores[round] || 0;
      return total;
    });
    return { player, index, total, totals };
  });

  entries.sort((a, b) => {
    if (a.total !== b.total) return b.total - a.total;
    if (roundCount === 0) {
      const myPriority = Number(b.player.id === currentPlayerId) - Number(a.player.id === currentPlayerId);
      if (myPriority) return myPriority;
    }
    // Walk backwards to the latest round when these players were not tied.
    for (let round = roundCount - 2; round >= 0; round--) {
      if (a.totals[round] !== b.totals[round]) return b.totals[round] - a.totals[round];
    }
    return a.index - b.index;
  });
  return entries.map(entry => entry.player);
};
